import React, { lazy, Suspense } from 'react';

import { Navigate, Route, type RouteObject, Routes } from 'react-router-dom';

import { Spinner } from '@pkg/components';
import { useBreakpoints } from '@pkg/hooks';

import { GAME_ROUTES } from '@app/client';
import { useSentryRoutes } from '@app/routes/hooks/useSentryRoutes';
import { PathParams } from '@app/routes/types';

const FantasyWishlist = lazy(() => import('@app/pages/FantasyWishlist/FantasyWishlist'));
const FantasyGames = lazy(() => import('@app/pages/FantasyGames/FantasyGames'));
const FantasyRules = lazy(() => import('@app/pages/FantasyRules/FantasyRules'));
const PageNotFound = lazy(() => import('@app/pages/PageNotFound').then((m) => ({ default: m.PageNotFound })));
const AboutSection = lazy(() =>
    import('@app/pages/FantasyWishlist/sections/AboutSection').then((m) => ({ default: m.AboutSection })),
);
const LeaderboardSection = lazy(() =>
    import('@app/pages/FantasyWishlist/sections/LeaderboardSection').then((m) => ({ default: m.LeaderboardSection })),
);
const LineupSection = lazy(() =>
    import('@app/pages/FantasyWishlist/sections/LineupSection').then((m) => ({ default: m.LineupSection })),
);
const TeamSection = lazy(() =>
    import('@app/pages/FantasyWishlist/sections/TeamSection').then((m) => ({ default: m.TeamSection })),
);
const FantasyTeamsReferral = lazy(() =>
    import('@app/pages/FantasyWishlist/components/JoinTeamAndRedirect').then((m) => ({ default: m.JoinTeam })),
);
const FantasyReferral = lazy(() =>
    import('@app/pages/FantasyWishlist/components/SaveRefferalAndRedirect').then((m) => ({
        default: m.SaveReferralAndRedirect,
    })),
);
const LineupSectionMobile = lazy(() =>
    import('@app/pages/FantasyWishlist/sections/MobileSection/components/MobileLineup').then((m) => ({
        default: m.MobileLineup,
    })),
);

function GameSectionRoutes() {
    const { isMobile } = useBreakpoints();

    const ROUTES_CONFIG: RouteObject[] = [
        { index: true, element: !isMobile ? <LineupSection /> : <LineupSectionMobile /> },
        { path: GAME_ROUTES.Leaderboard, element: <LeaderboardSection /> },
        { path: GAME_ROUTES.Team, element: <TeamSection /> },
        { path: GAME_ROUTES.About, element: <AboutSection /> },
        { path: '*', element: <PageNotFound /> },
    ];
    const sections = useSentryRoutes(ROUTES_CONFIG);
    return <Suspense fallback={<Spinner />}>{sections}</Suspense>;
}
function FantasyGameRoutes() {
    return (
        <Routes>
            <Route element={<FantasyWishlist />}>
                <Route path="*" element={<GameSectionRoutes />} />
            </Route>
        </Routes>
    );
}

export const FantasyRoutes = () => {
    return (
        <Routes>
            <Route index element={<FantasyGames />} />
            <Route path={`:${PathParams.CompetitionSlug}/*`} element={<FantasyGameRoutes />} />
            <Route path={`team/invite`} element={<FantasyTeamsReferral />} />
            <Route path={`refferal`} element={<FantasyReferral />} />
            <Route path={`rules`} element={<FantasyRules />} />
            <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
    );
};
